import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DealerProfile } from '@app/domain/model/dealer-profile';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DealerProfileService = /** @class */ (function () {
    function DealerProfileService(http) {
        this.http = http;
    }
    /**
     * Returns dealer profile.
     *
     * @param dealerId ID of the dealer, optional if currently logged dealer profile should be read
     */
    DealerProfileService.prototype.getDealerProfile = function (dealerId) {
        var headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        var url = 'dealers/' + ((null == dealerId) ? 'me' : dealerId) + '/';
        return this.http
            .get(url, { headers: headers })
            .pipe(map(function (response) { return response ? DealerProfile.fromJSON(response) : null; }));
    };
    DealerProfileService.ngInjectableDef = i0.defineInjectable({ factory: function DealerProfileService_Factory() { return new DealerProfileService(i0.inject(i1.HttpClient)); }, token: DealerProfileService, providedIn: "root" });
    return DealerProfileService;
}());
export { DealerProfileService };
